import type React from 'react';

import { Banner } from './component/Banner';

type AppDownloadBottomBannerProps = {
	sourceLocation: string;
	ownPetition: boolean;
	iOSBannerEnabled: boolean;
	androidBannerEnabled: boolean;
	desktopBannerEnabled: boolean;
	bottomOffsetPx?: number;
};

export const AppDownloadBottomBanner: React.FC<AppDownloadBottomBannerProps> = ({
	sourceLocation,
	ownPetition,
	iOSBannerEnabled,
	androidBannerEnabled,
	desktopBannerEnabled,
	bottomOffsetPx,
}) => {
	if (!ownPetition) return null;

	return (
		<Banner
			sourceLocation={sourceLocation}
			iOSBannerEnabled={iOSBannerEnabled}
			androidBannerEnabled={androidBannerEnabled}
			desktopBannerEnabled={desktopBannerEnabled}
			bottomOffsetPx={bottomOffsetPx}
		/>
	);
};
